<template>
  <v-card class="grey lighten-2 pb-0">
    <v-card-title class="align-start">
      <h4>{{ cardTitle }}</h4>
    </v-card-title>

    <loader :loading="isLoading" />

    <v-divider width="100%" />

    <v-row>
      <v-col
        class="listagem-tickets"
        lg="4"
        cols="12"
      >
        <ticket-list
          :fila-id="filaId"
          :is-gestor="isGestor"
          :tickets="tickets"
          :slas-contadores="slasContadores"
          :numero-de-paginas="numeroDePaginas"
          :pagina-atual.sync="paginaAtual"
          :filtro-categoria-listagem.sync="filtroCategoriaListagem"
          :get-tickets-and-select-first="getTicketsAndSelectFirst"
          @update:filtro-email="v => filtroEmail = v"
          @update:filtro-protocolo="v => filtroProtocolo = v"
          @update:filtro-agente-selecionado="v => filtroAgenteSelecionado = v"
          @update:filtro-sla-tipo-id="v => filtroSlaTipoId = v"
          @update:filtro-sla-tipo-alerta-id="v => filtroSlaTipoAlertaId = v"
        />
      </v-col>

      <v-expand-transition>
        <v-col
          v-if="ticketSelecionadoId"
          lg="8"
          cols="12"
        >
          <visualizacao-ticket
            :get-tickets="getTickets"
            :get-tickets-and-select-first="getTicketsAndSelectFirst"
            :active-tab="activeTab"
            :ticket-protocolo="ticketProtocoloLocale"
            @refetch-slas-contadores="refetchSlasContadores"
          />
        </v-col>
      </v-expand-transition>
    </v-row>
  </v-card>
</template>

<script>
import { onMounted, computed } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import Loader from '@/components/loader/Loader.vue'
import TicketList from '@/views/front-atendimento-listagem-tickets/TicketList.vue'
import VisualizacaoTicket from '@/views/front-atendimento-visualizacao-ticket/VisualizacaoTicket.vue'
import useAppStore from '@/store/app/app'
import useUserStore from '@/store/user'
import useAtendimentoStore from '@/store/atendimento'
import useListagemTickets from '@/composables/useListagemTickets'
import useTicketListSlasContadores from '@/composables/useTicketListSlasContadores'

export default {
  components: {
    Loader,
    TicketList,
    VisualizacaoTicket,
  },

  props: {
    filaId: {
      type: Number,
      default: null,
    },
    filaNome: {
      type: String,
      default: null,
    },
    isGestor: Boolean,
    activeTab: {
      type: Number,
      default: 0,
    },
    ticketProtocolo: {
      type: String,
      default: null,
    },
  },

  setup(props) {
    const { id: atendenteId } = storeToRefs(useUserStore())

    const {
      paginaAtual,
      numeroDePaginas,
      tickets,
      filtroEmail,
      filtroProtocolo,
      filtroCategoriaListagem,
      filtroAgenteSelecionado,
      filtroSlaTipoId,
      filtroSlaTipoAlertaId,
      getTickets,
      getTicketsAndSelectFirst,
    } = useListagemTickets(props.isGestor, props.filaId, props.protocolo)

    const { slasContadores, refetchSlasContadores } = useTicketListSlasContadores(props.filaId, props.isGestor ? null : atendenteId)

    const { isLoading, ticketSelecionadoId } = storeToRefs(useAtendimentoStore())
    const { isVerticalNavMini } = storeToRefs(useAppStore())

    onMounted(() => {
      isVerticalNavMini.value = true
    })

    const cardTitle = computed(() => {
      const ticket = tickets.value.find(it => it.id === ticketSelecionadoId.value)
      return `Atendimentos: ${ticket?.filaNome || props.filaNome}`
    })

    const ticketProtocoloLocale = computed(() => {
      const ticket = tickets.value.find(it => it.id === ticketSelecionadoId.value)
      return ticket?.protocolo
    })

    return {
      filtroEmail,
      filtroProtocolo,
      filtroCategoriaListagem,
      filtroAgenteSelecionado,
      filtroSlaTipoId,
      filtroSlaTipoAlertaId,
      tickets,
      paginaAtual,
      numeroDePaginas,
      isLoading,
      getTickets,
      getTicketsAndSelectFirst,
      slasContadores,
      refetchSlasContadores,
      ticketSelecionadoId,
      cardTitle,
      ticketProtocoloLocale,
    }
  },
}
</script>
